// extracted by mini-css-extract-plugin
export default {"resetButton":"eAKfftb","root":"sjSvV9U","value":"eNS7je6","withSynonym":"Low8AUo","type":"h2wCXL_","bullet":"cjNHZWh","label":"zGI0igH","synonym":"Tn1z9Vh"};